import axios from "axios";
import { cleanObject } from "helper/cleanObject";

const path = "/retro-pool";

export const retroPoolService = {
  async view(id) {
    return await axios.get(path + "/" + id);
  },

  async activityList(id, filter = {}) {
    let searchParams = new URLSearchParams(cleanObject(filter));
    return await axios.get(
      "/activity-puush-pool/retro-pool/" + id + "?" + searchParams.toString()
    );
  },
};
